<template>
  <div class="col-md-12 mx-auto">
    <b-container>
      <div class="mt-4 d-flex justify-content-between">
        <back-arrow :params="{operationId: operationId}"
                    :title="'Facture - '+facture.tostring"/>
        <div>
          <button class="show-action-btn edit mr-1" @click="clickOnEditBtn()">
            <pencil-icon size="18"/>
          </button>
          <button class="show-action-btn delete" @click="clickOnDeleteBtn()">
            <trash-icon size="18"/>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <b-card class="mt-2 mb-4 shadow-sm">

            <div v-if="facture.operationConstruction && facture.operationConstruction.id" class="row">
              <div class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('OperationConstruction') + " - " + facture.operationConstruction.name }}
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('operationConstruction.datedebut') }} :</div>
                  <div>{{ facture.operationConstruction.date }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('operationConstruction.datefin') }} :</div>
                  <div>{{ facture.operationConstruction.endDate }}</div>
                </div>
              </div>
            </div>
            <div class="row">
              <div v-if="facture && facture.id" class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('Facture') }}
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('facture.issued.date') }} :</div>
                  <div>{{ facture.issuedDate | formatDate }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('facture.paid.date') }} :</div>
                  <div>{{ facture.paidDate | formatDate }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('facture.PrixTTC') }} :</div>
                  <div>{{ factureMontant | formatEuro }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('facture.PrixTVA') }} :</div>
                  <div>{{ facture.prixTVA }}</div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('facture.Status') }} :</div>
                  <div>
                    <span :class="getStatusClass(facture.status)" class="status-badge-small">
                      {{ getStatusText(facture.status) }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="facture.operationHonoraire && facture.operationHonoraire.id" class="row">
              <div class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('OperationHonoraire') + " - " + facture.operationHonoraire.type }}
                </div>
              </div>
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('operationHonoraire.date') }} :</div>
                  <div>{{ facture.operationHonoraire.date }}</div>
                </div>
              </div>
            </div>
            <div
              v-else-if="facture.devis && facture.devis.id && facture.paymentDevis && facture.paymentDevis.id"
              class="row">
              <div class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('Devis.associated') }}
                </div>
              </div>
              <!-- 1. Numéro -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Numéro') }} :</div>
                  <div>
                    <span v-if="facture.devis.numero"
                          class="devis-numero-link bold-text"
                          @click="goToDevisShow">
                      {{ facture.devis.numero }}
                    </span>
                    <span v-else>N/A</span>
                  </div>
                </div>
              </div>
              <!-- 2. Artisan -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Artisan') }} :</div>
                  <div>{{ facture.devis.artisan || 'N/A' }}</div>
                </div>
              </div>
              <!-- 3. Travaux (Nom du poste de travaux) -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Travaux') }} :</div>
                  <div>{{ getTravauxName() }}</div>
                </div>
              </div>
              <!-- 4. Lot(s) -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Lot(s)') }} :</div>
                  <div>{{ getLotsInfo() }}</div>
                </div>
              </div>
              <!-- 5. Prix TTC (montant devis) -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t(`devis.Prix${isHT ? 'HT' : 'TTC'}`) }} :</div>
                  <div>{{ devisMontant | formatEuro }}</div>
                </div>
              </div>
              <!-- 6. Taux TVA -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Taux TVA') }} :</div>
                  <div>{{ facture.devis.tauxTVA || 'N/A' }}</div>
                </div>
              </div>
              <!-- 7. Statut du devis -->
              <div class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('Statut') }} :</div>
                  <div>
                    <span :class="getDevisStatusClass(facture.devis.status)" class="status-badge-small">
                      {{ getDevisStatusText(facture.devis.status) }}
                    </span>
                  </div>
                </div>
              </div>
              <!-- Échéancier de paiement (si présent) -->
              <div v-if="facture.paymentDevis && facture.paymentDevis.name" class="col-md-4">
                <div class="d-flex align-items-center mb-3">
                  <div class="bold-text mr-2">{{ $t('SchedulePayment.instance') }} :</div>
                  <div>{{
                      `${facture.paymentDevis.name} le ${facture.paymentDevis.date.split('-').reverse().join('/')} : ${facture.paymentDevis.amount}€ (${this.isHT ? 'HT' : 'TTC'})`
                    }}
                  </div>
                </div>
              </div>
            </div>

            <div v-if="facture.documents && facture.documents.length > 0" class="row">
              <div class="col-md-12">
                <div class="bold-text level-two-title my-2 main-red-color">
                  {{ $t('Document') }}
                </div>
              </div>
              <div class="col-md-12">
                <template v-for="document in facture.documents">
                  <div class="d-flex flex-column mb-4">
                    <div class="bold-text"> {{ document.name }}</div>
                    <b-link class="light-blue-color underline-text" v-on:click="getDocument(document.fileUrl)">
                      {{ document.fileName }}
                    </b-link>
                  </div>
                </template>
              </div>
            </div>
          </b-card>
        </div>
      </div>
    </b-container>

    <Item-delete-modal
      id="factureDeleteModal"
      :selectedItem="facture"
      controllerName="facturePayment"
      itemSingularName="facture"
      itemSingularNameUpp="Facture"
      @didDeleteItem="didDeleteFacture()">
    </Item-delete-modal>
  </div>
</template>

<script>
import api from "../../services/api"
import backArrow from "../../components/b122/BackArrow"
import ItemDeleteModal from "../../components/b122/ItemDeleteModal.vue"

export default {
  name: "OperationDevisShow",

  components: {
    ItemDeleteModal,
    backArrow,
  },

  data() {
    return {
      factureId: this.$route.params.factureId,
      operationId: this.$route.params.operationId,
      operationBilanId: this.$route.params.operationBilanId,
      facture: {},
      takeFrom: null,
      isHT: false
    }
  },

  computed: {
    getValue() {
      return property => (this.facture[property] || this.facture[property] === false) ? this.facture[property] : 'N/A'
    },

    factureMontant() {
      if (this.facture.prixTTC != null && this.isHT) {
        return this.facture.prixHT
      }
      return this.facture.prixTTC
    },

    devisMontant(){
      if (this.facture.devis) {
        if (this.facture.devis.prixHT != null && this.isHT) {
          return this.facture.devis.prixHT
        }
        return this.facture.devis.prixTTC
      }
      return 'N/A'
    }
  },

  filters: {
    formatDate: function (value) {
      if (!value) return 'N/A'
      value = value.split('-').reverse().join('/')
      return value
    },

    formatPayment: function (payment) {
      if (!payment) return 'N/A'
      let date = payment.date.split('-').reverse().join('/')
      return `${payment.name} le ${date} : ${payment.percentage}%`
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {
    async fetchData() {
      await this.getOperation()
      await this.fetchDevis()
      await this.fetchMovement()
    },

    async getOperation() {
      if (this.operationId != null) {
        await api
          .get(`/operation/${this.operationId}`)
          .then(response => {
            this.isHT = response.data.isHT
          })
      }
    },

    getDocument(fileUrl) {
      let url = process.env.SERVER_URL + fileUrl
      window.open(url, '_blank').focus()
    },

    async fetchDevis() {
      await api
        .get(`/facturePayment/${this.factureId}`)
        .then(response => {
          this.facture = response.data

        })
        .catch((error) => {
          this.$router.push({
            name: 'OperationIndex',
          })
        })
    },

    async fetchMovement() {
      if (this.facture.treasuryMovementUUID) {
        await api
          .get(`/treasury/getTakeFrom`, {
            params: {"objectUUID": this.facture.treasuryMovementUUID, "operationId": this.operationId}
          })
          .then(response => {
            this.takeFrom = response.data
          })
          .catch((error) => {
            this.$router.push({
              name: 'OperationIndex',
            })
          })
      }
    },

    clickOnEditBtn() {
      this.$router.push({
        name: 'OperationFactureEdit',
        params: {
          factureId: this.factureId,
          operationId: this.operationId
        },
        query: {
          from: 'OperationFactureShow'
        }
      })
    },

    clickOnDeleteBtn() {
      this.$bvModal.show('factureDeleteModal')
    },

    didDeleteFacture() {
      this.successToast((this.$i18n.t('Facture')) + ' "' + this.facture.numero + '" ' + this.$i18n.t('deleted'))
      this.$router.push({
        name: 'OperationFactureIndex',
        params: {
          operationId: this.operationId,
        }
      })
    },

    successToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 20000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: 'success',
        solid: true,
      })
    },

    getStatusClass(status) {
      switch (status) {
        case 'PAYE':
        case 'PAID':
          return 'status-paye'
        case 'A_PAYER':
        case 'UNPAID':
          return 'status-a-payer'
        case 'RESTE_A_PAYER':
          return 'status-reste-a-payer'
        case 'EN_ATTENTE':
        case 'PENDING':
          return 'status-en-attente'
        default:
          return 'status-default'
      }
    },

    getStatusText(status) {
      switch (status) {
        case 'PAYE':
        case 'PAID':
          return this.$t('status.paye')
        case 'A_PAYER':
        case 'UNPAID':
          return this.$t('status.aPayer')
        case 'RESTE_A_PAYER':
          return this.$t('status.resteAPayer')
        case 'EN_ATTENTE':
        case 'PENDING':
          return this.$t('status.enAttente')
        default:
          return status
      }
    },

    getTravauxName() {

      if (this.facture.operationConstruction && this.facture.operationConstruction.name) {
        return this.facture.operationConstruction.name
      }
      if (this.facture.operationHonoraire && this.facture.operationHonoraire.type) {
        return this.facture.operationHonoraire.type
      }


      if (this.facture.devis && this.facture.devis.posteName) {
        return this.facture.devis.posteName
      }

      return 'N/A'
    },

    getLotsInfo() {

      return (this.facture.devis && this.facture.devis.lotsInfo) || 'N/A'
    },

    getDevisStatusText(status) {
      switch (status) {
        case 'DRAFT':
          return 'Brouillon'
        case 'WAITING':
          return 'En attente'
        case 'VALIDATED':
          return 'Validé'
        case 'REFUSED':
          return 'Refusé'
        case 'EXPIRED':
          return 'Expiré'
        default:
          return status || 'N/A'
      }
    },

    getDevisStatusClass(status) {
      switch (status) {
        case 'VALIDATED':
          return 'status-paye'
        case 'DRAFT':
        case 'WAITING':
          return 'status-en-attente'
        case 'REFUSED':
        case 'EXPIRED':
          return 'status-a-payer'
        default:
          return 'status-default'
      }
    },

    goToDevisShow() {
      if (this.facture.devis && this.facture.devis.id) {
        this.$router.push({
          name: 'OperationDevisFactureShow',
          params: {
            operationId: this.operationId,
            devisId: this.facture.devis.id
          }
        })
      }
    },

  }
}
</script>

<style scoped>
/* Badge de statut moderne avec radius */
.status-badge {
  display: inline-block;
  padding: 6px 12px;
  font-size: 0.85rem;
  font-weight: 500;
  text-align: center;
  border-radius: 1000px;
  min-width: 120px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

/* Badge de statut petit pour les factures */
.status-badge-small {
  display: inline-block;
  padding: 4px 8px;
  font-size: 0.75rem;
  font-weight: 500;
  text-align: center;
  border-radius: 1000px;
  min-width: 80px;
  transition: all 0.2s ease;
  white-space: nowrap;
}

/* Payé - Vert clair avec texte vert foncé */
.status-paye {
  background-color: #317B221A;
  color: #317B22;
}

/* À payer - Rouge clair avec texte rouge foncé */
.status-a-payer {
  background-color: #9E04301A;
  color: #9E0430;
}

/* Reste à payer - Orange clair avec texte orange foncé */
.status-reste-a-payer {
  background-color: #fff3cd;
  color: #856404;
  border: 1px solid #ffeaa7;
}

/* En attente - Bleu clair avec texte bleu foncé */
.status-en-attente {
  background-color: #009DFF1A;
  color: #009DFF;
}

/* Par défaut - Gris clair */
.status-default {
  background-color: #f8f9fa;
  color: #6c757d;
  border: 1px solid #dee2e6;
}

/* Effet hover pour tous les badges */
.status-badge:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Style pour le numéro de devis cliquable */
.devis-numero-link {
  color: var(--main-color-hover);
  text-decoration: underline;
  cursor: pointer;

}

.devis-numero-link:hover {
  color: var(--main-color-hover);
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/views/OperationFacture/OperationFactureShow.vue